import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import UserDetailsLayout from "../../Component/Layouts/UserDetailsLayout";

const mdTheme = createTheme();

function UserDetails() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Investor Management" />
        <UserDetailsLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function ModifyUserDetails() {
  return <UserDetails/>;
}
